/**
 * Mira's apothecary (lifted from lantern-water's `prefabs/apothecary.js`): the house shell of
 * `house-shell.ts`, type 1, 5.8 × 4.5 m, walls 4.6 m, at the local origin (the house's centre, on its
 * terrace: the placement's `h`). Params: `ivy` (true) and `windowBoxes` (true), the
 * prototype's optional decorations.
 */
import * as THREE from 'three';
import { houseShell } from '../house-shell.ts';
import { flag } from '../kit.ts';
import type { Prefab } from './types.ts';

const model = { width: 5.8, depth: 4.5, height: 4.6, type: 1 } as const;

export const prefab: Prefab = {
  id: 'house_apothecary',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    houseShell(ctx, root, 0, 0, model.width, model.depth, model.height, model.type, { ivy: flag(ctx, 'ivy', true), windowBoxes: flag(ctx, 'windowBoxes', true) });
    return { root, sockets: { chimney: [model.width * 0.3, model.height + 2.65, -0.5], lantern: [model.width * 0.47, 2.15, model.depth / 2 + 0.51] } };
  },
};
